import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { KoReasonService } from '../../services/ko-reason/koReasonService';
import { KoReasonOption } from '../../type/entities/ko-reason-type';

export const filterKoReasonsByStatusEntity = (
    options: KoReasonOption[],
    statusEntity?: string
): KoReasonOption[] => {
    if (!statusEntity) return options;
    return options.filter((item) => item.statusEntity === statusEntity);
};

const useKoReasons = (initialFilters: Record<string, any> = {}) => {

    const { user } = useSelector((state: RootState) => state.auth);

    const [data, setData] = useState<KoReasonOption[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [filters, setFilters] = useState<Record<string, any>>({
        limit: 99999,
        filter_filters: { ...initialFilters }
    });

    const fetchKoReasons = async () => {
        setIsLoading(true);
        try {
            const service = new KoReasonService();
            const response = await service.listKoReasonsForSelect(filters);
            const resData = response.getResponseData();
            const rawData = resData?.data?.data ?? resData?.data;
            const arr = Array.isArray(rawData) ? rawData : [];

            const mappedData = arr.map((item: any) => ({
                value: item.id,
                label: item.name || item.label || item.id,
                statusEntity: item.statusEntity ?? item.status_entity ?? null,
            }));
            setData(mappedData);
        } catch (error) {
            console.log('Error fetching KO reasons:', error);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (user?.id) {
            fetchKoReasons();
        }
    }, [filters, user?.id]);

    return { koReasonsOptions: data, fetchKoReasons, isLoadingKoReasons: isLoading };
};

export default useKoReasons;
